import CustomToggle from 'components/Basic/CustomToggle/CustomToggle';
import { useMutation } from 'react-query';
import { useDispatch, useSelector } from 'react-redux';
import { AppDispatch, RootState } from 'store';
import { switchToolTypeToRoof } from './api';
import { fetchRoofData } from 'store/slices/RoofDataSlice/roofDataSlice';
import { ChangeEvent, useRef, useState } from 'react';
import { SwitchLoader } from './style';

type Props={
	reqToolType: ToolType;
	billAmount: number|null;
}

export default function ToolTypeSwitchToggle({reqToolType, billAmount}:Props ){

	const isPanelEditModeEnabled = useSelector((state: RootState) => state.panelSlice.data.activePanelMode);
	const hideSatelliteOverlay = useSelector((state: RootState) => state.toolNewPostions.data.hideSatelliteOverlay);
	const { uuid, panel, designType } = useSelector((state: RootState) => state.roofData.data);
	const inputRef = useRef<HTMLInputElement|null>(null);
	const availableToolToSwitchTo = reqToolType === 'roofwithsolar' ? 'SOLAR': 'ROOF';
	const dispatch = useDispatch<AppDispatch>();
	const [toggleChecked, setToggleChecked] = useState<boolean>(designType === availableToolToSwitchTo);

	const tooltypeToSwitchTo =
  toggleChecked ? (availableToolToSwitchTo === 'SOLAR' ? 'ROOF' : 'SOLAR'): availableToolToSwitchTo;

	const switchDesignType = useMutation(
		`switch-design-type-${uuid}`,
		async () => {
			const response = await switchToolTypeToRoof(uuid, tooltypeToSwitchTo ,panel.key, billAmount);
			return response;
		},
		{
			onSuccess: ()=>{

				dispatch(fetchRoofData({uuid, designType:tooltypeToSwitchTo}));
	
			},

			onError: (e)=>{
				console.log(e);
				setToggleChecked(false);
			}
		}
	
	);
	async function handleToggleChange(e: ChangeEvent<HTMLInputElement>){
		// TOD_O : confirm this flow:
		// on toggle first time only it shoukd fetch roof data,
		// hanlde switch to solar case also
		setToggleChecked(e.target.checked);
		// const roofEditingToggle = tooltypeToSwitchTo === 'ROOF' ? e.target.checked : false;
		
		// if(e.target.checked){
		// TODO: API CALL ...prevent on every toggle

		await switchDesignType.mutateAsync();
		// }
		// dispatch(toggleRoofEditingInSolar({toggle: roofEditingToggle }));
		// tooltypeToSwitchTo === 'ROOF'? roofEditingEnabled: !roofEditingEnabled
	}

	return (
		<>
			<CustomToggle 
				ref={inputRef}
				title={availableToolToSwitchTo}	
				disabled= {isPanelEditModeEnabled || switchDesignType.isLoading || hideSatelliteOverlay}
				checked= {toggleChecked}
				onChange={handleToggleChange}
			/>
			{switchDesignType.isLoading && <SwitchLoader className='loader'></SwitchLoader>}
		</>
	);
}